import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Oracle = () => {
  return (
    <StartInterviewLayout type="oracle"/>
  )
}

export default Oracle;